import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import { today } from "../../util/formatDate";
import * as XLSX from "xlsx";

export const useBox = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [date, setDate] = useState(today);
  const [statusBarang, setStatusBarang] = useState("Keluar");
  const [company, setCompany] = useState("");
  const [jenisBox, setJenisBox] = useState("");
  const [jumlah, setJumlah] = useState();
  const [keterangan, setKeterangan] = useState("");

  const [isRefresh, setIsRefresh] = useState(false);
  const [status, setStatus] = useState("Status");

  const [isError, setIsError] = useState(false);

  const [logKeluarMasukBox, setLogKeluarMasukBox] = useState();
  const [dataMonitoring, setDataMonitoring] = useState();
  const [subMenu, setSubMenu] = useState("Input");
  const [dataChart, setDataChart] = useState();

  const [filterMonth, setFilterMonth] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterYear, setFilterYear] = useState(
    moment().utcOffset("+0700").year()
  );

  const [produkPick, setProdukPick] = useState("");
  const [filterCustomer, setFilterCustomer] = useState("Pilih Customer");
  const [popUpDelete, setPopUpDelete] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [pickDataDelete, setPickDataDelete] = useState();
  const [dataFullHistory, setDataFullHistory] = useState();

  const [filterFrom, setFilterFrom] = useState(today);
  const [filterUntil, setFilterUntil] = useState(today);
  const [materialPick, setMaterialPick] = useState();
  const [companyPick, setCompanyPick] = useState();

  const [popUpDetail, setPopUpDetail] = useState(false);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLogInOutBox`,
      { tim: dataUser.tim, date: date },
      dataUser.auth,
      setLogKeluarMasukBox,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLogInOutBox`,
      { tim: dataUser.tim, type: "monitoring" },
      dataUser.auth,
      setDataMonitoring,
      ""
    );
    setIsRefresh(false);
  }, [isRefresh, subMenu, date]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLogInOutBox`,
      {
        tim: dataUser.tim,
        type: "chart",
        company: filterCustomer,
        material: produkPick,
        filterDate: `${filterYear}-${("0" + filterMonth).slice(-2)}`,
      },
      dataUser.auth,
      setDataChart,
      ""
    );
    setIsRefresh(false);
  }, [subMenu, filterMonth, filterYear, produkPick, filterCustomer]);

  const handleKirimBox = () => {
    if (!disabledButton) {
      if (company !== "" && jenisBox !== "" && jumlah) {
        postAxios(
          `${process.env.REACT_APP_ENDPOINT}/inOutBox`,
          {
            tim: dataUser.tim,
            date: date,
            statusBarang: statusBarang,
            company: company,
            id: jenisBox,
            weight: Number(jumlah),
            keterangan: keterangan,
            updateTime: moment().utcOffset("+0700").format(),
            updatedBy: dataUser.name,
            month: moment().utcOffset("+0700").month(),
          },
          dataUser.auth,
          "",
          ""
        );

        setIsError(false);
        setKeterangan("");
        setJumlah();
        setJenisBox("");
        setCompany("");
        setIsRefresh(true);
        setDisabledButton(false);
      } else {
        setIsError(true);
        setDisabledButton(false);
      }
    }
  };

  const searchFeature = (params) => {
    if (status !== "Status") {
      let searchStatus = [];

      logKeluarMasukBox &&
        logKeluarMasukBox.forEach((value) => {
          if (value.statusBahan === params) {
            searchStatus.push(value);
          }
        });
      return searchStatus;
    } else {
      return logKeluarMasukBox && logKeluarMasukBox;
    }
  };
  let dataTemp = searchFeature(status);

  let dataTempMonitor = [];

  dataMonitoring &&
    dataMonitoring.forEach((element) => {
      element &&
        element.data.forEach((obj) => {
          dataTempMonitor.push({
            id: obj.id,
            material: obj.material,
            updatedBy: obj.updatedBy,
            updateTime: obj.updateTime,
            weight: obj.weight,
            company: element.company,
          });
        });
    });

  let dataTanggal = [];
  let dataTanggalConverted = [];

  dataChart &&
    dataChart.map((ele) => {
      if (ele.material === produkPick) {
        let find = dataTanggal.find((i) => i === ele.date);
        if (!find) {
          dataTanggal.push(ele.date);
          dataTanggalConverted.push(moment(ele.date).format("DD-MM-YY"));
        }
      }
    });

  const findSameGrandTotalReject =
    dataChart &&
    dataChart.reduce((obj, item) => {
      let find = obj.find(
        (i) => i.date === item.date && i.statusBahan === item.statusBahan
      );
      let _d = {
        ...item,
      };
      if (find) {
        find.dataWeight = find.dataWeight + item.dataWeight;
      } else {
        obj.push(_d);
      }
      return obj;
    }, []);

  let masuk = [];
  let keluar = [];

  dataTanggal &&
    dataTanggal.map((ele) => {
      let findMasuk = findSameGrandTotalReject.find(
        (i) => i.date === ele && i.statusBahan === "Masuk"
      );
      let findKeluar = findSameGrandTotalReject.find(
        (i) => i.date === ele && i.statusBahan === "Keluar"
      );

      if (findMasuk && findKeluar) {
        masuk.push(findMasuk.dataWeight);
        keluar.push(-findKeluar.dataWeight);
      } else if (findMasuk && !findKeluar) {
        masuk.push(findMasuk.dataWeight);
        keluar.push(0);
      } else if (!findMasuk && findKeluar) {
        masuk.push(0);
        keluar.push(-findKeluar.dataWeight);
      }
    });
  let dataMerge = {
    masuk: masuk,
    keluar: keluar,
    tanggal: dataTanggalConverted,
  };

  const handleReset = () => {
    setProdukPick("");
    setFilterCustomer("GS");
    setFilterMonth(moment().utcOffset("+0700").month() + 1);
    setFilterYear(moment().utcOffset("+0700").year());
  };

  let templateData = {
    series: [
      {
        name: "Masuk",
        data: dataMerge.masuk,
      },
      {
        name: "Keluar",
        data: dataMerge.keluar,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 440,
        stacked: true,
      },
      colors: ["#008FFB", "#FF4560"],
      legend: {
        fontSize: 24,
        markers: {
          size: 14,
        },
        position: "top",
        itemMargin: {
          horizontal: 0,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 5,
          borderRadiusApplication: "middle",
          borderRadiusWhenStacked: "all",
          horizontal: true,
          barHeight: "90%",
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: 20,
        },
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      yaxis: {
        stepSize: 1,
        labels: {
          style: {
            fontSize: "18",
          },
        },
      },
      tooltip: {
        style: {
          fontSize: "20px",
        },
        shared: false,
        x: {
          formatter: function (val) {
            return val;
          },
        },
        y: {
          formatter: function (val) {
            return Math.abs(val);
          },
        },
      },
      title: {
        text: `Data keluar masuk Box bulan ${moment()
          .month(filterMonth)
          .add(-1, "months")
          .format("MMM")} : ${produkPick}`,
        style: {
          fontSize: "24",
          fontWeight: "0",
          color: "#263238",
        },
        margin: 0,
      },
      noData: {
        text: "Loading...",
        style: {
          fontSize: "36",
        },
      },
      xaxis: {
        categories: dataMerge.tanggal,
        labels: {
          formatter: function (val) {
            return Math.abs(Math.round(val));
          },
          style: {
            fontSize: "18",
          },
        },
      },
    },
  };

  const sortDataTanggal =
    dataChart &&
    dataChart.sort(function (a, b) {
      if (new Date(a.date) < new Date(b.date)) {
        return -1;
      }
      if (new Date(a.date) > new Date(b.date)) {
        return 1;
      }
      return 0;
    });

  const handleExportBox = () => {
    const filteredDataExcel =
      sortDataTanggal &&
      sortDataTanggal.map((obj, index) => {
        return {
          "No.": `${index + 1}.`,
          Produk: obj.material,
          Tgl: moment(obj.date).format("DD/MM/YY"),
          Keterangan: obj && obj.keterangan,
          Masuk: obj && obj.statusBahan === "Masuk" ? obj.dataWeight : "",
          Keluar: obj && obj.statusBahan === "Keluar" ? obj.dataWeight : "",
        };
      });

    let sumMasuk = 0;
    let sumKeluar = 0;

    sortDataTanggal &&
      sortDataTanggal.forEach((element) => {
        if (element.statusBahan === "Masuk") {
          sumMasuk += element.dataWeight;
        } else if (element.statusBahan === "Keluar") {
          sumKeluar += element.dataWeight;
        }
      });

    const GrandTotal = [
      {
        "No.": "",
        Produk: "",
        Tgl: "",
        Keterangan: "TOTAL",
        Masuk: sumMasuk && sumMasuk,
        Keluar: sumKeluar,
      },
    ];

    const workSheet = XLSX.utils.json_to_sheet(
      filteredDataExcel && filteredDataExcel.concat(GrandTotal)
    );

    workSheet["!cols"] = [
      { wch: 4 },
      { wch: 32 },
      { wch: 10 },
      { wch: 27 },
      { wch: 7 },
      { wch: 7 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Pemakaian");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(
      workBook,
      `${filterCustomer} PENGGUNAAN BOX ${produkPick} ${filterMonth}-${filterYear}.xlsx`
    );
  };

  const handleDeleteBox = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deleteHistoryInputBox`,
      {
        tim: dataUser.tim,
        data: pickDataDelete,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsRefresh(true);
    setDisabledButton(false);
    setPopUpDelete(false);
  };

  const filterFromUntil = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLogInOutBox`,
      {
        tim: dataUser.tim,
        type: "rangeHistory",
        company: companyPick,
        material: materialPick,
        filterFrom: filterFrom,
        filterUntil: filterUntil,
      },
      dataUser.auth,
      setDataFullHistory,
      ""
    );
  };

  const pickHistoryBox = (data) => {
    setCompanyPick(data.company);
    setMaterialPick(data.material);

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLogInOutBox`,
      {
        tim: dataUser.tim,
        type: "fullHistory",
        company: data.company,
        material: data.material,
      },
      dataUser.auth,
      setDataFullHistory,
      ""
    );
  };

  const sortTanggalBox =
    dataFullHistory &&
    dataFullHistory.sort(function (a, b) {
      if (Number(a.date) < Number(b.date)) {
        return -1;
      }
      if (Number(a.date) > Number(b.date)) {
        return 1;
      }
      return 0;
    });

  return {
    dataUser,
    date,
    setDate,
    statusBarang,
    setStatusBarang,
    company,
    setCompany,
    jenisBox,
    setJenisBox,
    jumlah,
    setJumlah,
    keterangan,
    setKeterangan,
    handleKirimBox,
    isError,
    setIsError,
    status,
    setStatus,
    setIsRefresh,
    dataTemp,
    subMenu,
    setSubMenu,
    dataTempMonitor,
    dataMerge,
    filterMonth,
    setFilterMonth,
    filterYear,
    setFilterYear,
    produkPick,
    setProdukPick,
    handleReset,
    templateData,
    filterCustomer,
    setFilterCustomer,
    handleExportBox,
    disabledButton,
    setDisabledButton,
    handleDeleteBox,
    popUpDelete,
    setPopUpDelete,
    setPickDataDelete,
    popUpDetail,
    setPopUpDetail,
    pickHistoryBox,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    filterFromUntil,
    sortTanggalBox,
  };
};
